import React from 'react';
import Modal from '../../ModalConversion';
import { UserForm } from './UserForm';

export function UserModal({ isOpen, onClose, initial, isNew, onSave, saving }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <div className="p-4">
                <h4 className="text-white mb-3">{isNew ? 'Nuevo usuario' : 'Editar usuario'}</h4>
                <UserForm
                    initial={initial}
                    isNew={isNew}
                    onSubmit={onSave}
                    saving={saving}
                    onCancel={onClose}
                />
            </div>
        </Modal>
    );
}

export default UserModal;